import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../modules/auth/AuthContext';
import { AppRoutes } from './routes';
import '../styles/global.css';

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
